
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import PostLoginLayout from "../components/layouts/PostLoginLayout";
import CredentialConfigComponents from "../components/CredentialConfigComponents";
import CredentialConfigTestComponents from "../components/CredConfigTest";

const CredentialConfig = () => {
  const location = useLocation();
  
  let CredentialConfigContainer = <CredentialConfigTestComponents />;

  return <PostLoginLayout childComponent={CredentialConfigContainer} noLeftPanel={false} loader={false}/>;
};

export default CredentialConfig;
